import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import moment from 'moment'
import { ExpandableBlocks, ContentBlockLoading } from 'components/ContentBlock'
import { getUserStatistics } from '../../gql/getUserStatistics'
import { useLazyQuery, useQuery } from '@apollo/client'
import Filter from './Filter'
import columns from './columns'
import DxDataTable from 'components/DxDataTable'
import useLocale from 'hooks/useLocale'
import { listCashRegisters } from 'gql/query'

const EmployeeTime = () => {
	const [expandedId, setExpandedId] = useState(null)
	const { data: cashRegisters } = useQuery(listCashRegisters, { fetchPolicy: 'cache-first' })

	const [t] = useTranslation()
	const locales = useLocale()

	const params = (filterParams) => {
		const { from, to, timeStart, timeEnd, cashRegisterIds, userIds } = filterParams
		const [dateStart] = moment(from).toISOString().split('T')
		const [dateEnd] = moment(to).toISOString().split('T')
		return {
			from: `${dateStart}T${timeStart}`,
			to: `${dateEnd}T${timeEnd}`,
			cashRegisterIds,
			userIds
		}
	}

	const [getStatistics, { data, loading, called }] = useLazyQuery(getUserStatistics)

	const handleSetFilter = (filterParams) => {
		setExpandedId('1')
		getStatistics({ variables: { params: params(filterParams) } })
	}

	return(
		<ExpandableBlocks expandedId={expandedId} onExpand={setExpandedId}>
			<Filter handleSetFilter={handleSetFilter} />
			{called &&
				<ContentBlockLoading
					isLoading={loading}
					topBorder
					alwaysExpanded
					blockId='1'
				>
					<DxDataTable
						id='employeeTable'
						label={t('statistic_section.sub_sections.employeesData')}
						columns={columns(t, locales, cashRegisters?.cashAssist?.listCashRegisters)}
						withSearch={false}
						data={data?.cashAssist?.getUserStatistics}
						excelExport
					/>
				</ContentBlockLoading>
			}
		</ExpandableBlocks>
	)
}

export default EmployeeTime
